/* Loaded for CVSDK Iframe Player only */
/* phpcs:ignore */
/* eslint-disable */
const execute_once_per_session = true;
const mrkl_cid = nbc.merkleId;
const mrkl_domain = nbc.domainName;
const mparticle_key = nbc.mParticleKey;

// Set mParticle global object with some default values.
window.mParticle = {
    config: {
        isDevelopmentMode: true, // set to false in production
    },
};

// Load the mParticle SDK.
(function (t) { window.mParticle = window.mParticle || {}; window.mParticle.EventType = { Unknown: 0, Navigation: 1, Location: 2, Search: 3, Transaction: 4, UserContent: 5, UserPreference: 6, Social: 7, Other: 8 }; window.mParticle.eCommerce = { Cart: {} }; window.mParticle.Identity = {}; window.mParticle.config = window.mParticle.config || {}; window.mParticle.config.rq = []; window.mParticle.config.snippetVersion = 2.3; window.mParticle.ready = function (t) { window.mParticle.config.rq.push(t) }; var e = ["endSession", "logError", "logBaseEvent", "logEvent", "logForm", "logLink", "logPageView", "setSessionAttribute", "setAppName", "setAppVersion", "setOptOut", "setPosition", "startNewSession", "startTrackingLocation", "stopTrackingLocation"]; var o = ["setCurrencyCode", "logCheckout"]; var i = ["identify", "login", "logout", "modify"]; e.forEach(function (t) { window.mParticle[t] = n(t) }); o.forEach(function (t) { window.mParticle.eCommerce[t] = n(t, "eCommerce") }); i.forEach(function (t) { window.mParticle.Identity[t] = n(t, "Identity") }); function n(e, o) { return function () { if (o) { e = o + "." + e } var t = Array.prototype.slice.call(arguments); t.unshift(e); window.mParticle.config.rq.push(t) } } var dpId, dpV, config = window.mParticle.config, env = config.isDevelopmentMode ? 1 : 0, dbUrl = "?env=" + env, dataPlan = window.mParticle.config.dataPlan; dataPlan && (dpId = dataPlan.planId, dpV = dataPlan.planVersion, dpId && (dpV && (dpV < 1 || dpV > 1e3) && (dpV = null), dbUrl += "&plan_id=" + dpId + (dpV ? "&plan_version=" + dpV : ""))); var mp = document.createElement("script"); mp.type = "text/javascript"; mp.async = true; mp.src = ("https:" == document.location.protocol ? "https://jssdkcdns" : "http://jssdkcdn") + ".mparticle.com/js/v2/" + t + "/mparticle.js" + dbUrl; var c = document.getElementsByTagName("script")[0]; c.parentNode.insertBefore(mp, c) }
)(mparticle_key);


window.mParticle.ready(
  // Que up a function inside the mParticle.ready method.
  // This function will be executed once mParticle is avaiilable and ready.
  function () {
    // This method check if the browser session item has been set or not.
    // Also logs the session value for debugging purposes.
    function shouldExecuteForSession(onetime = true) {
      console.log(`onetime=${onetime} session-item=${sessionStorage.getItem("nbcu-dcr-session-executed")} executed=${(!sessionStorage.getItem("nbcu-dcr-session-executed") || !onetime ? true : false)}`);
      return !sessionStorage.getItem("nbcu-dcr-session-executed") || !onetime ? true : false;
    }

    // Check if mParticle MPID exists and if it does then return it.
    function checkIfMPIDExist() {
      return window.mParticle.Identity.getCurrentUser() && window.mParticle.Identity.getCurrentUser().getMPID();
    }

    // Function that checks for MPID and initializes DCR.
    // If MPID not available tries to initialize after 3 seconds.
    function dcr() {
      if (checkIfMPIDExist()) {
        console.log("MPID Found, no need for timeout");
        initializeMerkle();
      } else {
        console.log("No MPID Found, waiting...");
        setTimeout(initializeMerkle, 3000);
      }
    }

    // Main function that initializes DCR first with MPID if exists.
    // If MPID does not exists initializes without it.
    function initializeMerkle() {
      if (checkIfMPIDExist()) {
        const mpid = window.mParticle.Identity.getCurrentUser().getMPID();
        window._svq = window._svq || []; window._svq.push(['_setUID', mpid]); window._svq.push(['_trackPageView']); (function (d, c) { var mrklsv = d.createElement(c); mrklsv.type = 'text/javascript'; mrklsv.src = `https://nbcu.track.securedvisit.com/js/sv.js?sv_cid=${mrkl_cid}&sv_origin=${mrkl_domain}`; var mrkls = d.getElementsByTagName(c)[0]; mrkls.parentNode.insertBefore(mrklsv, mrkls); })(document, 'script');
        console.log("Initializing DCR with MPID");
      } else {
        console.log("Initializing DCR without MPID");
        window._svq = window._svq || []; window._svq.push(['_trackPageView']); (function (d, c) { var mrklsv = d.createElement(c); mrklsv.type = 'text/javascript'; mrklsv.src = `https://nbcu.track.securedvisit.com/js/sv.js?sv_cid=${mrkl_cid}&sv_origin=${mrkl_domain}`; var mrkls = d.getElementsByTagName(c)[0]; mrkls.parentNode.insertBefore(mrklsv, mrkls); })(document, 'script');
      }
    }

    console.log("Firing mParticle event...");

    const urlSearchParams = new URLSearchParams(window.location.search);

    // Fires off mParticle Page Load event with some parameters.
    mParticle.logEvent(
      'Page Load',
      mParticle.EventType.Navigation,
      {
        'Page Name': document.querySelector('title').text,
        'URL': window.location.href.toString(),
        'Product': window.location.hostname,
        'UTM Campaign': urlSearchParams && Object.fromEntries(urlSearchParams.entries()).utm_campaign ? Object.fromEntries(urlSearchParams.entries()).utm_campaign : 'None',
        'UTM Source': urlSearchParams && Object.fromEntries(urlSearchParams.entries()).utm_source ? Object.fromEntries(urlSearchParams.entries()).utm_source : 'None',
        'UTM Content': urlSearchParams && Object.fromEntries(urlSearchParams.entries()).utm_content ? Object.fromEntries(urlSearchParams.entries()).utm_content : 'None',
        'UTM Term': urlSearchParams && Object.fromEntries(urlSearchParams.entries()).utm_term ? Object.fromEntries(urlSearchParams.entries()).utm_term : 'None',
        'UTM Medium': urlSearchParams && Object.fromEntries(urlSearchParams.entries()).utm_medium ? Object.fromEntries(urlSearchParams.entries()).utm_medium : 'None',
        'UTM Tags': urlSearchParams && Object.fromEntries(urlSearchParams.entries()).utm_tags ? Object.fromEntries(urlSearchParams.entries()).utm_tags : 'None'
      }
    );

    // Checks if session is set and it initializes DCR if its not set and sets it.
    if (shouldExecuteForSession(execute_once_per_session)) {
      sessionStorage.setItem("nbcu-dcr-session-executed", true);
      dcr();
    }
  }
);
